var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSave(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "save_svg__aidb-icon save_svg__aidb-icon-save",
    width: "1em",
    height: "1em",
    "data-name": "\\u56FE\\u5C42 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.94 17.97c-.34 0-.62-.28-.62-.62s.28-.62.62-.62c.24 0 .48-.02.72-.07 1.65-.34 2.84-1.8 2.84-3.48s-1.17-3.11-2.79-3.46l-.33-.07-.12-.32c-.8-2.15-2.88-3.6-5.17-3.6S7.73 7.16 6.93 9.3l-.13.33-.35.06c-1.71.3-2.95 1.77-2.95 3.49s1.18 3.12 2.81 3.47c.24.05.5.08.75.08.35 0 .62.28.62.62s-.28.62-.62.62-.69-.04-1.01-.11c-2.2-.47-3.8-2.44-3.8-4.69s1.51-4.12 3.63-4.65c1.07-2.44 3.52-4.05 6.2-4.05s5.17 1.64 6.22 4.11c2.01.6 3.44 2.48 3.44 4.6a4.815 4.815 0 01-4.81 4.8z"
  })));
}
export default SvgSave;